'use client'

import { useEffect, useState } from 'react'
import { SITE_METADATA } from '~/data/site-metadata'
import { useHotels } from '~/hooks/use-hotels'

export function useDynamicTitle(hotelId?: string) {
  const { hotels } = useHotels()
  const [title, setTitle] = useState(SITE_METADATA.title)

  useEffect(() => {
    if (hotelId && hotels && hotels.length > 0) {
      const hotel = hotels.find((h) => h.hotelId === hotelId)
      if (hotel && hotel.fullName) {
        setTitle(hotel.fullName)
      } else {
        setTitle(SITE_METADATA.title)
      }
    } else {
      setTitle(SITE_METADATA.title)
    }
  }, [hotelId, hotels])

  useEffect(() => {
    document.title = title
  }, [title])

  return title
}
